module.exports = __webpack_public_path__ + "static/media/smart-logo-512x512.fac8a694.png";